module.exports = "/assets/landing-dw/instagram/insta-feed-5.jpg?kyenz8u";